import { createContext, useContext } from 'react';

// Single source of truth für CoinGecko Markt-Daten (Live-Preis, 24h-Δ,
// Sparkline, Logo-URL). State lebt aktuell in App.js — Provider reicht
// nur durch. Spätere Migration: state hierher ziehen.
//
// Schema: marketData = { [coinId]: { price, chg, chg7d, mcap, image, ... } }
export const MarketDataContext = createContext({
  marketData: {},
  refresh: async () => {},
  loading: false,
});

export function useMarketData() {
  return useContext(MarketDataContext);
}
